import { BrandingClient } from '@frontend/account/api';
import { Branding, BrandingQueryParams } from '@frontend/account/types';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import React, { useState } from 'react';

const ID = 'branding-select';
export const BrandingSelectV2 = (props: ObjectSelectProps<Branding, BrandingQueryParams>) => {
    const [v, cV] = useState<Branding | null>(null);
    return (
        <ObjectSelectInput<Branding, BrandingQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label='Branding'
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={{ ...props.queryParams }}
            value={v}
            searchValueOverwrite={props.searchValueOverwrite}
            isClearable={props.isClearable}
            idValue={props.value || v?.id}
            fetch={(arg) => BrandingClient.fetchBrandings({ ...arg, sort_field: 'domain', sort_direction: 'asc' })}
            itemLabel={(obj: Branding) => obj.domain}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            subset={props.subset}
            isOpenOverwrite={props.isOpenOverwrite}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'branding_id',
                          fetch: (id) =>
                              BrandingClient.resolveBrandings([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
